{
  "el": {
    "published": {
      "labels": {
        "notPublished": "Μη δημοσιευμένο",
        "publishedCustomer": "Δημοσιευμένο για πελάτες",
        "publishedCustomerPartners": "Δημοσιευμένο για πελάτες και συνεργάτες",
        "publishedPartners": "Δημοσιευμένο για συνεργάτες"
      },
      "publish_mode": {
        "inherit": "Ακολούθηση προτύπου",
        "inherit_info": "Διατηρεί την κατάσταση δημοσίευσης κάθε στοιχείου από το πρότυπο"
      }
    }
  }
}
